<template>
  <div id="app" :class="{ 'mobile-app': isMobile() }">
    <router-view></router-view>
  </div>
</template>

<script>
import { isMobile } from '@/utils'

export default {
  name: 'app',

  methods: {
    isMobile
  },

  mounted() {
    if (isMobile()) {
      document.body.style.minWidth = '100vw'
      document.body.style.overflowX = 'hidden'
    }
  }
}
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
}

.mobile-app {
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>




// WEBPACK FOOTER //
// app.vue?29a7c92f